import { TermsModalComponent } from './terms-modal/terms-modal.component';
import { WelcomeModalComponent } from './welcome-modal/welcome-modal.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { IdleLogoutModalComponent } from './idle-logout-modal/idle-logout-modal.component';
import { MediaModalComponent, MediaSelectionSource } from './media-modal/media-modal.component';
import { MessageModalComponent } from './message-modal/message-modal.component';
import { RideDurationModalComponent } from './ride-duration-modal/ride-duration-modal.component';
import { RideDistanceModalComponent } from './ride-distance-modal/ride-distance-modal.component';
import { RideNotesModalComponent } from './ride-notes-modal/ride-notes-modal.component';
import { HorseOwnershipTransferResponseModalComponent } from './horse-ownership-transfer-response-modal/horse-ownership-transfer-response-modal.component';
import { HorseGeneralInvitationResponseModalComponent } from './horse-general-invitation-response-modal/horse-general-invitation-response-modal.component';
import { ActionButtonModal } from './action-modal/action-modal.component';
import { TransferSubscriptionModalComponent } from './transfer-subscription-modal/transfer-subscription-modal.component';
import { HorseListModalComponent } from './horse-list-modal/horse-list-modal.component';
import { UpdateSubscriptionPaymentMethodModalComponent } from './update-subscription-payment-method-modal/update-subscription-payment-method-modal.component';

export const modals = [
    TermsModalComponent,
    WelcomeModalComponent,
    ConfirmModalComponent,
    ActionButtonModal,
    IdleLogoutModalComponent,
    MediaModalComponent,
    MessageModalComponent,
    RideDurationModalComponent,
    RideDistanceModalComponent,
    RideNotesModalComponent,
    HorseOwnershipTransferResponseModalComponent,
    HorseGeneralInvitationResponseModalComponent,
    TransferSubscriptionModalComponent,
    HorseListModalComponent,
    UpdateSubscriptionPaymentMethodModalComponent
];

export {
    TermsModalComponent,
    WelcomeModalComponent,
    ConfirmModalComponent,
    ActionButtonModal,
    IdleLogoutModalComponent,
    MediaModalComponent,
    MediaSelectionSource,
    MessageModalComponent,
    RideDurationModalComponent,
    RideDistanceModalComponent,
    RideNotesModalComponent,
    HorseOwnershipTransferResponseModalComponent,
    HorseGeneralInvitationResponseModalComponent,
    HorseListModalComponent,
    UpdateSubscriptionPaymentMethodModalComponent
};
